(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/tickets-table/components/ticket-item.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/tickets-table/components/ticket-item.js');
"use strict";


const Input = svs.ui.form.Input;
const {
  TableCell,
  TableRow
} = svs.ui.reactTable;
const Brand = svs.ui.ReactBrand;
const TicketItem = _ref => {
  let {
    article,
    handleOnChange,
    handleOnBlur,
    isEditable,
    articleCount,
    maximumCount
  } = _ref;
  const total = (parseInt(articleCount, 10) || 0) * article.price;
  return React.createElement(TableRow, {
    "data-testid": "ticket-row"
  }, React.createElement(TableCell, null, React.createElement("span", null, React.createElement(Brand, {
    brand: article.iconId,
    class: "margin-right-1 hidden-xs",
    square: true
  }), article.ticketTitle)), React.createElement(TableCell, null, article.price), React.createElement(TableCell, null, isEditable ? React.createElement(Input, {
    className: "ticket-item-input-count",
    "data-testid": article.ticketTitle,
    max: maximumCount,
    min: "0",
    name: article.ticketTitle,
    onBlur: e => handleOnBlur(e, article),
    onChange: e => handleOnChange(e, article),
    type: "number",
    value: articleCount || ''
  }) : React.createElement("span", null, articleCount)), React.createElement(TableCell, null, svs.utils.format.Currency(total), "\xA0 kr"));
};
svs.ticket_partner.sharedComponents.ticketsTable.components.TicketItem = TicketItem;

 })(window);